import { mapState, mapGetters } from 'vuex'

import { storage } from '@shared/utils/storage'

import Loadable from '@shared/mixins/loadable'

import Translatable from '@shared/mixins/translatable'

export default {
  template: '#tutorial',
  components: {
  },
  data() {
    const excluded = new Set(
      this.excludedSteps.trim().split(',').map(x => x.trim() - 1)
    )
    const initial = this.initialSteps.map((x, i) => {
      x.index = i
      return x
    })

    return {
      mediaQuery: '',
      show: 0,
      language: $('html').attr('lang'),
      steps: excluded.size > 0
        ? initial.filter((x, i) => !excluded.has(i))
        : initial,
      navButtons: [
        {
          mobile:  {
            uk: '/static/images/prev-mobile-uk.png',
            ru: '/static/images/prev-mobile-ru.png'
          },
          tablet: {
            uk: '/static/images/prev-tablet-uk.png',
            ru: '/static/images/prev-tablet-ru.png'
          },
          desktop: {
            uk: '/static/images/prev-desktop-uk.png',
            ru: '/static/images/prev-desktop-ru.png'
          }
        },
        {
          mobile:  {
            uk: '/static/images/close-mobile-uk.png',
            ru: '/static/images/close-mobile-ru.png'
          },
          tablet: {
            uk: '/static/images/close-tablet-uk.png',
            ru: '/static/images/close-tablet-ru.png'
          },
          desktop: {
            uk: '/static/images/close-desktop-uk.png',
            ru: '/static/images/close-desktop-ru.png'
          }
        }

      ],
      tutorialBg: {
        mobile: {
          uk: '/static/images/tutorial-mobile-uk.png',
          ru: '/static/images/tutorial-mobile-ru.png'
        },
        tablet: {
          uk: '/static/images/tutorial-tablet-uk.png',
          ru: '/static/images/tutorial-tablet-ru.png'
        },
        desktop: {
          uk: '/static/images/tutorial-desktop-uk.png',
          ru: '/static/images/tutorial-desktop-ru.png'
        }
      }

    }
  },
  props: [ 'visible', 'initialSteps', 'excludedSteps' ],
  watch: {},
  computed: {
    tutorialBground() {
      return this.tutorialBg[this.mediaQuery][this.language]
    },
    isVisible() {
      return this.visible
    },
    image() {
      return this.steps[this.show][this.mediaQuery][this.language]
    },
    index() {
      return this.steps[this.show].index
    },
    prevSrc() {
      return this.navButtons[0][this.mediaQuery][this.language]
    },
    endSrc() {
      return this.navButtons[1][this.mediaQuery][this.language]
    }
  },
  created() {
    this.getMobile()
    this.$nextTick(function() {
      window.addEventListener('resize', this.getMobile)
    })
  },
  mounted() {
  },
  updated() {
    if($('.tutorial-wrapper__img').length) {
      let posY = $('.tutorial-wrapper__img').position().top
      $(window).scrollTop(posY)
    }
  },

  methods: {
    endTutorial() {
      this.show = 0
      this.$emit('close-tutorial')
    },
    prevTip() {
      this.show--

    },
    nextTip() {
      let index = this.show + 1
      if(index >= this.steps.length ) {
        this.endTutorial()
      } else {

        this.show = index
      }
    },
    getMobile() {
      this.mediaQuery = window.innerWidth < 840 ?  'mobile' : window.innerWidth < 1030 ?  'tablet'  : 'desktop'
      return this.mediaQuery
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getMobile)
  }
}



// WEBPACK FOOTER //
// ./src/js/calendar/components/tutorial.js